import { TabbedPage } from "../../components/TabbedPage";
import { TaxRatesPage } from "../tax/TaxRatesPage";
import { ExchangeRatesPage } from "../tax/ExchangeRatesPage";

/** Merged Tax Rates + Exchange Rates — both gated identically (ROLES_WITH_TAX_FX_ACCESS),
 * so no per-tab role filtering is needed. */
export function TaxCurrencyPage() {
  return (
    <TabbedPage
      title="Tax & Currency"
      defaultTab="rates"
      tabs={[
        { key: "rates", label: "Tax Rates", content: <TaxRatesPage /> },
        { key: "exchange", label: "Exchange Rates", content: <ExchangeRatesPage /> },
      ]}
    />
  );
}
